import faqsApi from '@/api/faqs'

export default {
  namespaced: true,
  state: {
    item: {},
    items: []
  },
  getters: {
    categories: state => state.items
      .map(item => item.category)
      .filter((item, index, self) => item && self.findIndex(temp => temp?.code === item?.code) === index)
      .sort((a, b) => a?.weight > b?.weight ? 1 : -1),
    getItemsByCategory: state => category => state.items
      .filter(item => item.category?.code === category.code)
  },
  mutations: {
    SET_ITEMS (state, items, rootState) {
      state.items = items || []
    },
    SET_ITEM (state, item) {
      state.item = item || {}
    }
  },
  actions: {
    async fetch ({ commit, state, rootState }) {
      const { data: { data } } = await faqsApi.index({
        'page[all]': 1,
        'filter[publish]': 1,
        'filter[site_version]': rootState.siteVersions.item?.id
      })

      commit('SET_ITEMS', data)
    }
  }
}
